import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  width: 100%;
`

export const StatCardContainer = styled.div<{ $color: 'default' | 'success' | 'warning' | 'danger' }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 12px;
  border-radius: 10px;

  ${({ $color }) =>
    $color === 'default' &&
    `
    background-color: ${Tokens.ColorBackground};
    color: ${Tokens.ColorTextPrimary};
  `}
  ${({ $color }) =>
    $color === 'success' &&
    `
    background-color: ${Tokens.ColorUISuccessLight};
    color: ${Tokens.ColorUISuccess};
  `}
  ${({ $color }) =>
    $color === 'warning' &&
    `
    background-color: ${Tokens.ColorUIWarnLight};
    color: ${Tokens.ColorUIWarnDark};
  `}
  ${({ $color }) =>
    $color === 'danger' &&
    `
    background-color: #FFE4E8;
    color: ${Tokens.ColorUIDanger};
  `}
`

export const StatValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  color: inherit;
`

export const StatLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${Tokens.ColorTextSecondary};
`

export const ErrorTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const ErrorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 240px;
  overflow-y: auto;
`

export const ErrorRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #ffe4e8;
`

export const ErrorLine = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${Tokens.ColorUIDanger};
  white-space: nowrap;
`

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${Tokens.ColorTextSecondary};
`
